module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel-suns_access_02-edf9ee622635fc730ac2675d2abd65ce.jpg";